import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { List } from 'immutable';
import get from 'lodash/get';

const propTypes = {
  events: PropTypes.instanceOf(List),
};

const defaultProps = {
  events: List(),
};

const PackageEvents = ({ events }) => {
  if (!get(events, 'size', 0)) { return null; }

  const eventList = [];
  events.forEach((event, index) => {
    const background = (index % 2 === 1) ? 'background-color-white' : 'background-color-off-white';
    const startDate = moment(event.startTime);
    eventList.push(
      <div key={event.id} className={background}>
        <div className="row text-size-12 text-weight-light background-color-hover-blue-light-grey-lighten">
          <div className="col-md-10 col-xs-9">{event.event_name}</div>
          <div className="col-md-2 col-xs-3 text-align-right">{startDate.format('MMM D')}</div>
        </div>
      </div>,
    );
  });

  return (
    <div className="border-color-light-grey border-side-top border-style-solid padding-top-20 padding-bottom-40">
      <h3 className="text-color-dark-slate text-size-20 text-weight-bold row margin-top-0 margin-bottom-10">Package Includes</h3>
      <div className="info-list">{eventList}</div>
    </div>
  );
};

PackageEvents.propTypes = propTypes;
PackageEvents.defaultProps = defaultProps;
export default PackageEvents;
